import { render, staticRenderFns } from "./PrePurchaseInspection.vue?vue&type=template&id=47ab5f5d&"
import script from "./PrePurchaseInspection.vue?vue&type=script&lang=js&"
export * from "./PrePurchaseInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports